import React from "react";
import "./AdventureCabSection.css";
import citycab from "../../assets/citycab.png";
import economycab from "../../assets/economycab.png";
import luxurycab from "../../assets/luxurycab.png"
import { Link } from "react-router-dom";
const AdventureCabSection = () => {
  return (
    <div className="adventure-container">
      <div className="adventure-header">
        <h2>
          Adventure Starts Here – <span>With Your Perfect Cab</span>
        </h2>
      <Link to="/adventure-cab-view-more"><button className="adventure-top-view-btn">View More</button></Link>
      </div>

      <div className="adventure-cab-cards">
        {/* Card 1 */}
        <div className="adventure-cab-card">
          <div className="adventure-rate-badge">Rs--/hr</div>
          <img src={citycab} alt="City Cab" className="adventure-cab-image" />
          <h3>City Cab</h3>
          <p>Perfect for city rides</p>
       <Link to="/citycab"><button className="adventure-card-btn">View More</button></Link>
        </div>

        {/* Card 2 */}
        <div className="adventure-cab-card">
          <div className="adventure-rate-badge">Rs--/hr</div>
          <img src={economycab} alt="Economy" className="adventure-cab-image" />
          <h3>Economy</h3>
          <p>Budget-friendly option</p>
       <Link to="/economycab"><button className="adventure-card-btn">View More</button></Link>
        </div>

        {/* Card 3 */}
        <div className="adventure-cab-card">
          <div className="adventure-rate-badge">Rs--/hr</div>
          <img src={luxurycab} alt="Luxury" className="adventure-cab-image" />
          <h3>Luxury</h3>
          <p>Premium comfort rides</p>
       <Link to="/luxury-cab">   <button className="adventure-card-btn">View More</button></Link>
        </div>
      </div>
    </div>
  );
};

export default AdventureCabSection;
